// Featured videos shown on the Home page "Watch" section
export const HOME_VIDEOS = [
  {
    id: "UAxM_p8tepg",
    eyebrow: "Foster Famous",
    title: "You already love them.",
    subtitle: "Celebrated voices shaped by foster care.",
    href: "https://youtu.be/UAxM_p8tepg",
  },
  {
    id: "qSOqSQYfdL8",
    eyebrow: "Foster Care Anthem · Track 05",
    title: "We All Got History",
    subtitle: '"Honor the past. Don\'t live there."',
    link_to: "/anthem/song/we-all-got-history",
    link_label: "Open Track",
  },
  {
    id: "K8W0Opkwj0g",
    eyebrow: "On Screen",
    title: "Movies & TV Shows About Foster Care / Adoption",
    subtitle: "The foster experience told through film and television.",
    href: "https://youtu.be/K8W0Opkwj0g",
  },
  {
    id: "hGQVLZxFwhM",
    eyebrow: "Foster History",
    title: "How we got here.",
    subtitle: "A look back at the history of the foster care system.",
    href: "https://youtu.be/hGQVLZxFwhM",
  },
];
